import { DatapointPerformancePeriodEnum } from "api/ux/src";
const PerformancePeriodToStringMap = [
    { order: 99, performancePeriod: DatapointPerformancePeriodEnum.Itd, stringValue: "ITD" },
    { order: 0, performancePeriod: DatapointPerformancePeriodEnum.OneQuarter, stringValue: "QTD" },
    { order: 0, performancePeriod: DatapointPerformancePeriodEnum.OneQuarter, stringValue: "1Q" },
    { order: 1, performancePeriod: DatapointPerformancePeriodEnum.SixMonths, stringValue: "6M" },
    { order: 2, performancePeriod: DatapointPerformancePeriodEnum.Ytd, stringValue: "YTD" },
    { order: 2, performancePeriod: DatapointPerformancePeriodEnum.OneYear, stringValue: "1Y" },
    { order: 3, performancePeriod: DatapointPerformancePeriodEnum.TwoYears, stringValue: "2Y" },
    { order: 4, performancePeriod: DatapointPerformancePeriodEnum.ThreeYears, stringValue: "3Y" },
    { order: 5, performancePeriod: DatapointPerformancePeriodEnum.FiveYears, stringValue: "5Y" },
    { order: 6, performancePeriod: DatapointPerformancePeriodEnum.TenYears, stringValue: "10Y" }
];
export const getPerformancePeriodAsStringIndex = (s) => PerformancePeriodToStringMap.findIndex((p) => p.stringValue === s);
export const getPerformancePeriodOrder = (d) => PerformancePeriodToStringMap.find((p) => p.performancePeriod === d)?.order;
export const performancePeriodLessThanOrEqual = (perfA, perfB) => {
    const orderA = getPerformancePeriodOrder(perfA);
    const orderB = getPerformancePeriodOrder(perfB);
    if (orderA && orderB) {
        return orderA <= orderB;
    }
    return false;
};
